module.exports = __webpack_public_path__ + "static/media/sideicon.7d80809a.png";